import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IDestinoResponse, IDestinoRequest, IDestinoVarRequest, IDestinoVarResponse } from '../interfaces/destino.interface';

@Injectable({
  providedIn: 'root'
})
export class DestinoService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}MntoSolicitudes/GetDestinos4`;
  private readonly API_URL_VAR = `${environment.apiNewBackBaseUrl}MntoSolicitudes/GetDestinosVar`;

  constructor(private http: HttpClient) { }

  getDestinos(request: IDestinoRequest): Observable<IDestinoResponse> {
    return this.http.post<IDestinoResponse>(this.API_URL, request);
  }

  getDestinosVar(payload: IDestinoVarRequest): Observable<IDestinoVarResponse> {
    return this.http.post<IDestinoVarResponse>(this.API_URL_VAR, payload);
  }

  getDestinoByClave(clave: string): Observable<IDestinoResponse> {
    const payload = {
      que: 5,
      tope: '',
      clave,
      descripcion: ''
    };
    return this.http.post<IDestinoResponse>(this.API_URL, payload);
  }
} 